// src/components/Sidebar.jsx
import React from "react";
import { Link } from "react-router-dom";
import "./Sidebar.css";

export default function Sidebar({ menuActive, setMenuActive }) {
  const closeMenu = () => setMenuActive(false);

  return (
    <div className={`sidebar ${menuActive ? "active" : ""}`}>
      <div className="branding">
        <img
          src={process.env.PUBLIC_URL + "/talkvee.png"}
          alt="Talkvee Logo"
          className="logo"
        />
        <h2 className="brand-text">Match Up. Game On</h2>
        <p>Random video chat with built-in challenges.</p>
      </div>

      <nav className="nav-links">
        <Link to="/" onClick={closeMenu}>Home</Link>
        <Link to="/ranking" onClick={closeMenu}>Ranking</Link>
        <Link to="/about" onClick={closeMenu}>About Us</Link>
        <Link to="/settings" onClick={closeMenu}>Settings</Link>
        <Link to="/privacy" onClick={closeMenu}>Privacy Policy</Link>
        <Link to="/terms" onClick={closeMenu}>Terms of Service</Link>
      </nav>

      <details className="sidebar-accordion">
        <summary className="sidebar-accordion__summary">FAQ & Alternatives</summary>
        <ul className="sidebar-accordion__links">
          {/* Main SEO Keywords */}
          <li><Link to="/random-video-chat" onClick={closeMenu}>Random Video Chat</Link></li>
          <li><Link to="/talk-to-strangers" onClick={closeMenu}>Talk to Strangers</Link></li>
          <li><Link to="/meet-strangers-online" onClick={closeMenu}>Meet Strangers Online</Link></li>
          <li><Link to="/video-chat-with-strangers" onClick={closeMenu}>Video Chat with Strangers</Link></li>
          <li><Link to="/free-online-video-chat" onClick={closeMenu}>Free Online Video Chat</Link></li>

          {/* Competitor Alternatives - Strategic SEO Boost */}
          <li style={{ borderTop: '1px solid #333', marginTop: '10px', paddingTop: '10px' }}>
            <Link to="/omegle-alternative" onClick={closeMenu} style={{ fontWeight: 'bold', color: '#1a73e8' }}>
              Omegle Alternative
            </Link>
          </li>
          <li><Link to="/ome-tv-alternative" onClick={closeMenu}>OmeTV Alternative</Link></li>
          <li><Link to="/monkey-app-alternative" onClick={closeMenu}>Monkey App Alternative</Link></li>
        </ul>
      </details>
    </div>
  );
}